import { createFileRoute } from '@tanstack/react-router';
import { NotificationSettingsPage } from '@/features/settings/NotificationSettingsPage';

export const Route = createFileRoute('/app/settings/notifications')({
  component: NotificationSettingsPage,
  staticData: { title: 'Notifications · Settings' },
});
